const s = {
  name: "Glasses",
  dimensions: { width: 40, height: 16 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 16" style="enable-background:new 0 0 40 16;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,0C5.9,0,2.6,3.1,2.1,7H0v2h2.1c0.5,3.9,3.9,7,7.9,7c4.4,0,8-3.6,8-8c0-0.2,0-0.4,0-0.7
			C18.6,7.1,19.3,7,20,7c0.7,0,1.4,0.1,2,0.3c0,0.2,0,0.4,0,0.7c0,4.4,3.6,8,8,8c4.1,0,7.4-3.1,7.9-7H40V7h-2.1
			c-0.5-3.9-3.9-7-7.9-7c-3.5,0-6.5,2.2-7.6,5.4C21.7,5.1,20.9,5,20,5c-0.9,0-1.7,0.1-2.4,0.4C16.5,2.2,13.5,0,10,0z M4,8
			c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6c0,3.3-2.7,6-6,6C6.7,14,4,11.3,4,8z M24,8c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6c0,3.3-2.7,6-6,6
			C26.7,14,24,11.3,24,8z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Glasses
};
